import { useState } from 'react';
import { connect } from 'react-redux';
import { Alert, Forms } from '../..';
import { IDataStorage, Settings } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import VoucherForm from '../../../pages/admin/config/voucher/form';
import API from '../../../services/api';
import { IVoucher } from '../../../services/api/entity/model';
import Service from '../../../services/common/services/formservice';
import { ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import Security from '../../../services/seguridad';
import Loader from '../../loader';
import { Button, Column, DataTable, Dialog } from '../../prime';
import { Secciones } from '../index.service';
import styles from './index.module.scss';
import { VoucherEditIn } from '../../../model/operaciones';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

let voucherForm : Service<IVoucher> | undefined = undefined;

function CardSeccionVouchers({ storage, t,
  data,
  onUpdateFields,
} : IProps) {
  const [ voucherDialog, setVoucherDialog ] = useState<{ saving?: boolean } | undefined>(undefined);
  
  const agregarVoucher = (service?: Service<IVoucher>) => {
    const dto = service?.getEntity();
    if (!dto?.success || !dto.data) return;
    setVoucherDialog({ saving: true });
    
    (dto.data as any).idoperacion = data?.operacion?.id; // id de operacion
    
    const obj = {
      idOperacion: data?.operacion?.id,
      archivo: dto.data.file,
      idioma: dto.data.idioma,
      ididioma: dto.data.idioma,
      idIdioma: dto.data.idioma,
      numero: dto.data.codigo,
      descripcion: dto.data.descripcion
    } as VoucherEditIn;
    API.OperacionesController().Voucher().upsert2(obj).then(upd => {
      Alert.reponse(upd);
      if (upd.success && !!upd.data && data?.operacionvouchers) {
        Alert.info(t("Seccion.Voucher.Dialog.Voucher.Guardar.Success.Titulo"), t("Seccion.Voucher.Dialog.Voucher.Guardar.Success.Msg"));
        data.operacionvouchers.push({ ...obj, archivourl: upd.data.archivo?.url } as any);  ///TODO: GGR - revisar si anda
        onUpdateFields([ { field: `random`, value: Math.random() } ])
      }
    })
    .catch(err => Alert.error(t("Seccion.Voucher.Dialog.Voucher.Guardar.Error.Titulo"), err))
    .finally(() => {
      setVoucherDialog(undefined);
    })
  }
  

  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Vouchers}`)}</div>
    
    <div className='p-grid'>
      <div className='p-col-12 p-lg-12 p-p-2'>
        <Button 
          className='p-button-success p-button-sm' style={{ marginBottom: 8 }} 
          icon="fas fa-upload" label={t("Seccion.Voucher.Btn.operacionvoucher.Add")} 
          disabled={!Security.HasPermiso(87)} 
          onClick={() => setVoucherDialog({ })}
        />
        <div className="datatable-responsive-demo">
          <DataTable 
            value={data?.operacionvouchers?.reduce((acum, curr) => {
              if (!acum.find(p => p.numero === curr.numero && p.descripcion === curr.descripcion)) acum.push({ numero: curr.numero, descripcion: curr.descripcion });
              return acum;
            }, [] as any[]).sort((a,b) => a.numero > b.numero ? 1 : -1)
            }
            className="p-datatable-responsive-demo"
          >
            <Column field='numero' header={t("Seccion.Field.operacionvoucher.codigo")} />
            {/*<Column field='idioma' header={t("Seccion.Field.operacionvoucher.idioma")} body={row => <>{t(`@API.Idioma#${row.ididioma ?? 'undefined'}`)}</>} />*/}
            <Column field='descripcion' header={t("Seccion.Field.operacionvoucher.descripcion")} body={row => <>{(row.descripcion ?? '').startsWith("@") ? t(row.descripcion) : row.descripcion}</>}/>
            <Column 
              header={t("@API.Generic#Unkown")} style={{ width: 130 }} 
              body={(row,col) => {
                var voucher = data?.operacionvouchers?.find(p => p.numero === row.numero && p.descripcion === row.descripcion && ![1,2].includes(p.ididioma ?? -1) )
                if (!voucher) return <></>
                return <div>
                  <Button 
                    label={t("@API.Generic#Download")}
                    className='p-button-text p-button-sm'
                    onClick={() => window.open(voucher?.archivourl ?? `${Settings().api.url}file/Operaciones/${voucher?.idarchivo}`) }
                  />
                </div>}
              } 
            />
            <Column 
              header={t("@API.Idioma#es")} style={{ width: 105 }} 
              body={(row,col) => {
                var voucher = data?.operacionvouchers?.find(p => p.numero === row.numero && p.descripcion === row.descripcion && p.ididioma === 1);
                if (!voucher) return <></>
                return <div>
                  <Button 
                    label={t("@API.Generic#Download")}
                    className='p-button-text p-button-sm'
                    onClick={() => window.open(voucher?.archivourl ?? `${Settings().api.url}file/Operaciones/${voucher?.idarchivo}`) }
                  />
                </div>}
              } 
            />
            <Column 
              header={t("@API.Idioma#en")} style={{ width: 105 }} 
              body={(row,col) => {
                var voucher = data?.operacionvouchers?.find(p => p.numero === row.numero && p.descripcion === row.descripcion && p.ididioma === 2);
                if (!voucher) return <></>
                return <div>
                  <Button 
                    label={t("@API.Generic#Download")}
                    className='p-button-text p-button-sm'
                    onClick={() => window.open(voucher?.archivourl ?? `${Settings().api.url}file/Operaciones/${voucher?.idarchivo}`) }
                  />
                </div>}
              } 
            />
          </DataTable>
        </div>
        
        <Dialog 
          visible={!!voucherDialog} 
          onHide={() => setVoucherDialog(undefined)} 
          header={t("Seccion.Voucher.Dialog.Voucher.Titulo")} 
          style={{ width: 800, maxWidth: '100%' }} 
          footer={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
            <Loader loading={voucherDialog?.saving}>
              <Button icon="pi pi-times" label={t("Seccion.Voucher.Dialog.Voucher.Cerrar")} className="p-button-secondary" onClick={() => setVoucherDialog(undefined)} tooltip={t("Seccion.Voucher.Dialog.Voucher.Cerrar.Tooltip")} tooltipOptions={{ position: 'top' }} style={{ marginLeft: 10 }} />
              <Button icon="pi pi-save" label={t("Seccion.Voucher.Dialog.Voucher.Agregar")} className="p-button-primary" tooltip={t("Seccion.Voucher.Dialog.Voucher.Agregar.Tooltip")} tooltipOptions={{ position: 'top' }} onClick={() => agregarVoucher(voucherForm)} />
            </Loader>
          </div>}
        >
          <Loader loading={voucherDialog?.saving}>
            <VoucherForm refService={f => voucherForm = f} />
          </Loader>
        </Dialog>
      </div>
      
      {!!data?.operacion?.erroremitiendo && <div className='p-col-12 p-lg-12 p-p-2'>
        <Forms.InputArea
          height={150}
          className={styles["fix-form-component"]}
          title={t("Seccion.Field.operacion.errorEmitiendo")}
          disabled={true}
          value={data?.operacion?.erroremitiendo}
        />
      </div>}

      {!!data?.operacion?.errorenviarvoucher && <div className='p-col-12 p-lg-12 p-p-2'>
        <Forms.InputArea
          height={150} 
          className={styles["fix-form-component"]}
          title={t("Seccion.Field.operacion.errorEnviarVoucher")}
          disabled={true}
          value={data?.operacion?.errorenviarvoucher}
        />
      </div>}
    </div>

    <div className='p-grid'>
      <div className='p-col-12 p-lg-12 p-p-2'>
        <div className="datatable-responsive-demo">
          <DataTable 
            value={data?.operacionvoucheraudit?.sort((a,b) => new Date(a.creafecha!) > new Date(b.creafecha!) ? 1 : -1)}
            className="p-datatable-responsive-demo"
          >
            <Column field='creafecha' header={t("Seccion.Field.operacionvoucheraudit.creafecha")} 
              body={row => <>{window.format(row.creafecha, "dd/MM/yyyy HH:mm")}</>} 
            />
            <Column field='creausulogin' header={t("Seccion.Field.operacionvoucheraudit.creausulogin")} />
            <Column field='accion' header={t("Seccion.Field.operacionvoucheraudit.accion")} 
              body={row => <>{t(`@API.OperacionVoucherAudit#Accion.${row.accion}`)}</>} 
            />
            <Column field='vouchernumero' header={t("Seccion.Field.operacionvoucheraudit.vouchernumero")} />
            <Column field='cambiofield' header={t("Seccion.Field.operacionvoucheraudit.cambiofield")} 
              body={row => <>{row.cambiofield && t(`@API.OperacionVoucherAudit#CambioField.${row.cambiofield}`)}</>} 
            />
            <Column field='cambiooldvalue' header={t("Seccion.Field.operacionvoucheraudit.cambiooldvalue")}
              body={row => <>{showAuditValue(row.cambiofield, row.cambiooldvalue, t)}</>}
            />
            <Column field='cambionewvalue' header={t("Seccion.Field.operacionvoucheraudit.cambionewvalue")} 
              body={row => <>{showAuditValue(row.cambiofield, row.cambionewvalue, t)}</>}
            />
          </DataTable>
        </div>
      </div>
    </div>
  </div>;
}
export default connect((s:any) => ({ storage:s.main }))(CardSeccionVouchers);


function showAuditValue(field: string, value: string, t: FxTranslate) {
  if (["FechaDesde", "FechaHasta"].includes(field)) return window.format(value, "dd/MM/yyyy");
  if (["PasajeroVip", "PasajeroEnViaje"].includes(field)) return t(`@API.Generic#${value === "1" ? "Si" : "No"}`);
  if (["PasajeroEnViajeOrigen"].includes(field) && !!value) return t(`@Entity#Pais.Nombre.${value}`);
  return value;
}